import { NgModule } from "@angular/core";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent } from "@fuse/components/navigation";
import { MessagesModule } from "app/layout/common/messages/messages.module";
import { NotificationsModule } from "app/layout/common/notifications/notifications.module";
import { SearchModule } from "app/layout/common/search/search.module";
import { SharedModule } from "app/shared/shared.module";
import { CompactLayoutComponent } from "./compact.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FuseFullscreenComponent } from "@fuse/components/fullscreen";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";

@NgModule({
  declarations: [CompactLayoutComponent],
  exports: [CompactLayoutComponent],
  imports: [
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MessagesModule,
    NotificationsModule,
    SearchModule,
    SharedModule,
    MatTooltipModule,
    FuseFullscreenComponent,
    FuseLoadingBarComponent,
    FuseHorizontalNavigationComponent,
    FuseVerticalNavigationComponent,
    // FuseNavigation
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CompactLayoutModule {}
